import { cn } from '@/lib/utils';

/**
 * Stipjes, geen tekst: de stap zelf staat al in de knoppen eronder.
 *
 * Stond in `NieuwGesprek`. De uitleg loopt langs dezelfde soort stappen, en twee
 * keer dezelfde rij stipjes tekenen is één plek te veel om ze uit de pas te
 * laten lopen.
 */
export function StapStippen({ stap, aantal }: { stap: number; aantal: number }) {
  return (
    <div aria-label={`Stap ${stap + 1} van ${aantal}`} className="flex justify-center gap-1.5">
      {Array.from({ length: aantal }, (_, i) => (
        <span
          className={cn('size-1.5 rounded-full', i === stap ? 'bg-primary' : 'bg-muted')}
          key={i}
        />
      ))}
    </div>
  );
}
